var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 2C12.3086 2 2 12.3086 2 25C2 37.6914 12.3086 48 25 48C37.6914 48 48 37.6914 48 25C48 12.3086 37.6914 2 25 2ZM25 4C36.6094 4 46 13.3906 46 25C46 36.6094 36.6094 46 25 46C13.3906 46 4 36.6094 4 25C4 13.3906 13.3906 4 25 4ZM36 14L10 26H24V40L36 14Z",
    fill: "#171725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestDetails);
export default __webpack_public_path__ + "static/media/RequestDetails.a492e527bf8d21a14383e9b4af5ae6f9.svg";
export { ForwardRef as ReactComponent };